














































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { vue as i18nService } from "@/services/i18n";

interface SegCol { key: string; label: string }

// Expense key → column key in KBK seg cols
const EXPENSE_KEY_TO_COL: Record<string, string> = {
    gr: 'fgr', pgr: 'pgr', abp: 'abp', prg: 'prg', ppr: 'ppr', spf: 'spf'
}

const TK = 'modules.budget_execution_monitoring.reports_constructor.recon_pf_kf'

@Component({ name: "report-recon-pf-kf" })
export default class ReportReconPfKf extends Vue {
    @Prop({ required: true })
    public tableData!: any[];

    @Prop({ default: false })
    public includeEarlierLoaded304!: boolean;

    @Prop({ default: () => [] })
    public segmentations!: Array<{ value: string; active: boolean }>;

    @Prop({ default: () => [] })
    public expenses!: Array<{ key: string; active: boolean }>;

    public currentPage = 1;
    public readonly perPage = 100;

    tr(key: string): string {
        return String(this.$t(`${TK}.${key}`))
    }

    get activeExpenseColKeys(): Set<string> | null {
        if (!this.expenses || this.expenses.length === 0) return null
        const active = this.expenses.filter(e => e.active).map(e => EXPENSE_KEY_TO_COL[e.key]).filter(Boolean)
        return active.length > 0 ? new Set(active) : null
    }

    get visibleColumns(): SegCol[] {
        const segCols: Record<string, SegCol[]> = {
            REGION: [{ key: 'region', label: this.tr('region') }],
            GU: [{ key: 'gu', label: this.tr('gu') }],
            KBK: [
                { key: 'fgr', label: this.tr('fgr') },
                { key: 'pgr', label: this.tr('pgr') },
                { key: 'abp', label: this.tr('abp') },
                { key: 'prg', label: this.tr('prg') },
                { key: 'ppr', label: this.tr('ppr') },
                { key: 'spf', label: this.tr('spf') },
            ],
        }
        const result: SegCol[] = []
        for (const seg of this.segmentations) {
            if (!seg.active) continue
            const cols = segCols[seg.value]
            if (!cols) continue
            if (seg.value === 'KBK' && this.activeExpenseColKeys) {
                result.push(...cols.filter(c => this.activeExpenseColKeys!.has(c.key)))
            } else {
                result.push(...cols)
            }
        }
        return result
    }

    get dataRows(): any[] {
        return this.tableData.filter((r: any) => r.rowType !== 'header')
    }

    get currentItems(): any[] {
        const start = (this.currentPage - 1) * this.perPage;
        return this.dataRows.slice(start, start + this.perPage);
    }

    get paginationStart(): number {
        return (this.currentPage - 1) * this.perPage + 1;
    }

    get paginationEnd(): number {
        const end = this.currentPage * this.perPage;
        return end > this.dataRows.length ? this.dataRows.length : end;
    }

    get months() {
        return [
            { num: 0,  label: this.tr('jan') },
            { num: 1,  label: this.tr('feb') },
            { num: 2,  label: this.tr('mar') },
            { num: 3,  label: this.tr('apr') },
            { num: 4,  label: this.tr('may') },
            { num: 5,  label: this.tr('jun') },
            { num: 6,  label: this.tr('jul') },
            { num: 7,  label: this.tr('aug') },
            { num: 8,  label: this.tr('sep') },
            { num: 9,  label: this.tr('oct') },
            { num: 10, label: this.tr('nov') },
            { num: 11, label: this.tr('dec') },
        ]
    }

    fmt(val: number | null | undefined): string {
        if (val == null || val === 0) return '0'
        return this.$n(val)
    }

    diff(kaz: number | null | undefined, ea: number | null | undefined): number {
        return (kaz ?? 0) - (ea ?? 0)
    }

    fmtDiff(val: number): string {
        return (val > 0 ? '+' : '') + this.$n(val)
    }

    cellDiffClass(val: number): string {
        if (val === 0) return ''
        return val > 0 ? 'cell-diff-pos' : 'cell-diff-neg'
    }

    kazDate(row: any): string | null {
        for (let m = 0; m < 12; m++) {
            if (row[`date_${m}`]) return row[`date_${m}`]
        }
        return null
    }
}
